import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle,Grid  } from '@material-ui/core';
import KpiEntryLogItem from './KpiEntryLogItem.js';
import LoadMoreButton from '../../LoadMoreButton.js';
import { EVENT_LOG } from '../../../../utils/const.js';
import useKpiEventLogs from '../../../../hooks/objective/eventLog/useKpiEventLogQuery.js';

/**
 * @component
 *
 * @param {boolean} open      - Controls whether the dialog is open.
 * @param {Function} setOpen  - Function to toggle the dialog's open state.
 * @param {Object} objective  - The objective associated with the KPI logs.
 * @param {Object} kpi        - The KPI whose deleted logs are displayed.
 *
 * @returns {JSX.Element} A Material-UI Dialog showing deleted KPI logs.
 */
const DeletedKpiEntryLogs = ({ open, setOpen, objective, kpi }) => {
  const { t } = useTranslation();

  const { KPI_ENTRIES } = EVENT_LOG;

  const { data, fetchNextPage, hasNextPage, isLoading, isFetching } = useKpiEventLogs({
    objective,
    kpi,
    subjectType: KPI_ENTRIES
  });

  const kpiEntryLogs = data?.pages.flat() ?? [];

  return (
    <Dialog
      open={ open }
      onClose={ () => setOpen(false) }
      maxWidth='md'
      fullWidth
    >
      <DialogTitle>
        {t('objective.eventlog.type.kpi_entry')}
      </DialogTitle>
      <DialogContent>
        {kpiEntryLogs.map((event, index) => (
          <KpiEntryLogItem
            key={ `${event.name}-${index}` }
            event={ event }
          />
        ))}
        <Grid container justifyContent="center">
          <LoadMoreButton
            loading={ isFetching || isLoading }
            canLoadMore={ hasNextPage }
            loadMore={ fetchNextPage }
            loadMoreTranslation={ t('objective.eventlog.loadMoreBtn') }
            noMoreToLoadTranslation={ t('objective.eventlog.NoMoreEvents') }
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={ () => setOpen(false) } color='primary'>
          { t('objective.dialog.cancel') }
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletedKpiEntryLogs;